export default "__VITE_ASSET__b81ce059__"